import { HelpOutlined, OpenInNew } from '@mui/icons-material'
import { Box, Link, Stack } from '@mui/material'
import Paper from '@mui/material/Paper'
import { useTranslation } from 'react-i18next'

import CustomTypography from '@/components/dataDisplay/CustomTypography'

export function RaspiPropertiesInfoPanel() {
  const { t } = useTranslation()

  return (
    <Paper sx={{ p: 3, marginBottom: 2 }}>
      <Stack spacing={2}>
        <Stack alignItems="center" direction="row" spacing={1}>
          <HelpOutlined />
          <CustomTypography sx={{ mb: 2 }} variant="h3">
            {t('controllers.configuration.raspi_properties.info.label')}
          </CustomTypography>
        </Stack>
        <CustomTypography>{t('controllers.configuration.raspi_properties.info.text')}</CustomTypography>
        <Box>
          <CustomTypography color="grey.500" variant="caption">
            Connectivity settings
          </CustomTypography>
          <CustomTypography sx={{ whiteSpace: 'pre-wrap' }}>{`• Modbus settings
• Serial port settings`}</CustomTypography>
        </Box>
        <Box>
          <CustomTypography color="grey.500" variant="caption">
            Settings for specific modules
          </CustomTypography>
          <CustomTypography sx={{ whiteSpace: 'pre-wrap' }}>
            {`• Power meters: ION, Tillquist, Modbus
• Relays: GPIO, KMTronic, time relay
• HSL (Huawei Smart Logger 1000A) control module`}
          </CustomTypography>
        </Box>
        <Box>
          <CustomTypography color="grey.500" variant="caption">
            New steering and metering integrations
          </CustomTypography>
          <CustomTypography sx={{ whiteSpace: 'pre-wrap' }}>
            {`• GreyBox
• Generic Modbus power-controlled steering
• Generic Modbus power metering`}
          </CustomTypography>
        </Box>
        <Stack alignItems="center" direction="row" spacing={1}>
          <OpenInNew />
          <Link
            href="https://app.notion.com/p/sympower/Configuration-options-of-raspi-custom-properties-14228c3d46fa80939606e2c93494db2c"
            rel="noopener noreferrer"
            sx={{ textDecoration: 'underline', background: 'none', border: 'none' }}
            target="_blank"
          >
            {t('controllers.configuration.raspi_properties.info.notion_link_description')}
          </Link>
        </Stack>
      </Stack>
    </Paper>
  )
}
